export const toUtcDate = (date: Date | string) => {
  const currentDate = new Date(date);
  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1;
  const year = currentDate.getFullYear();

  return year + '-' + month + '-' + day + 'T00:00:00.000Z';
};
